import config from '@/config';
import http from '@/utils/http';
import { USER_VISUALIZATION_TOKEN } from '@/constants';
import { SyncVisualizationToken } from '@/types/api/sync';

export async function apiGetVisualizationToken(): Promise<SyncVisualizationToken> {
  const response = await http.get<SyncVisualizationToken>(
    `${config.syncApiUrl}userapi/visualization/token`,
  );

  return response.data;
}

export async function getVisualizationToken(): Promise<string> {
  const existingToken = localStorage.getItem(USER_VISUALIZATION_TOKEN);

  if (existingToken) {
    return existingToken;
  }

  const data = await apiGetVisualizationToken();
  localStorage.setItem(USER_VISUALIZATION_TOKEN, data.token);

  return data.token;
}
